import React from "react";

import { IBriefProduct } from "../../../../types/product/ibrief-product/ibrief-product.interface";

import { ProductTableRow } from "../products-table-row/products-table-row.component";

import { ProductsTableBodyProps } from "./products-table-body.props";
import { ProductTableBodyStyled } from "./products-table-body.styles";

export const ProductsTableBody = (props: ProductsTableBodyProps) => {
  const getProduct = (id: number): IBriefProduct =>
    props.products.find((product) => product.id === id) as IBriefProduct;

  return (
    <ProductTableBodyStyled>
      {/* @ts-ignore */}
      {props.fields.map((field, index) => (
        <ProductTableRow
          briefEndDatePassed={props.briefEndDatePassed}
          errors={props.errors?.products?.[index]}
          key={field.key}
          index={index}
          control={props.control}
          disabled={props.disabled}
          field={field}
          getValues={props.getValues}
          isBuyGet={props.isBuyGet}
          onBuyGetStatusUpdate={props.onBuyGetStatusUpdate}
          onRemove={props.onRemoveProduct}
          pageType={props.pageType}
          product={getProduct(field.id)}
          resourceType={props.resourceType}
          setValue={props.setValue}
          triggerValidation={props.triggerValidation}
          workOrderGetProductsList={props.workOrderGetProductsList}
          workOrderTemplate={props.workOrderTemplate}
        />
      ))}
    </ProductTableBodyStyled>
  );
};
